import NextLink from 'next/link'
import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { assetUrl } from 'utils/url'

export type PelaksanaanPegawaiCardProps = {
  className?: string
}

export function PelaksanaanPegawaiCard({
  className,
}: PelaksanaanPegawaiCardProps) {
  return (
    <section
      className={clsx(
        'p-6 shadow-card rounded-lg bg-white space-y-6',
        className
      )}
    >
      <header className="flex space-x-6 items-center">
        <img
          alt=""
          src={assetUrl('/illustrations/img-assessment-indicator.png')}
          width={84}
          height={84}
          className="flex-shrink-0"
        />

        <div className="space-y-1">
          <Text variant="heading-lg" as="h2">
            Pelaksanaan Kinerja
          </Text>
          <Text color="subdued">Laksanakan berdasarkan Perencanaan Anda.</Text>
        </div>
      </header>

      <div className="space-y-4 px-3">
        <div className="flex items-center justify-start py-4 px-6 border border-gray-30 rounded-lg gap-4">
          <img
            src={assetUrl('/illustrations/img-badge-star-ribbon-pro.png')}
            alt=""
            width={64}
            height={64}
            className="flex-shrink-0"
          />

          <Text variant="heading-sm" as="h3">
            Pelaksanaan Tugas Pokok
          </Text>

          {/* TODO: Enable this button when the feature is ready */}
          <Button color="black" className="min-w-40 ml-auto" disabled={true}>
            Lakukan <span className="sr-only">Pelaksanaan Tugas Pokok</span>
          </Button>
        </div>

        <div className="flex items-center justify-start py-4 px-6 border border-gray-30 rounded-lg gap-4">
          <img
            src={assetUrl('/illustrations/img-badge-star.png')}
            alt=""
            width={64}
            height={64}
            className="flex-shrink-0"
          />

          <Text variant="heading-sm" as="h3">
            Praktik Kinerja
          </Text>

          <NextLink
            href={`${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan`}
            passHref
          >
            <Button
              as="a"
              type={undefined}
              color="black"
              className="min-w-40 ml-auto !inline-flex"
            >
              Lakukan <span className="sr-only">Praktik Kinerja</span>
            </Button>
          </NextLink>
        </div>

        <div className="flex items-center justify-start py-4 px-6 border border-gray-30 rounded-lg gap-4">
          <img
            src={assetUrl('/illustrations/img-document.png')}
            alt=""
            width={64}
            height={64}
            className="flex-shrink-0"
          />

          <Text variant="heading-sm" as="h3">
            Pengembangan Kompetensi
          </Text>

          {/* TODO: Enable this button when the feature is ready */}
          <Button color="black" className="min-w-40 ml-auto" disabled={true}>
            Lakukan <span className="sr-only">Pengembangan Kompetensi</span>
          </Button>
        </div>

        <div className="flex items-center justify-start py-4 px-6 border border-gray-30 rounded-lg gap-4">
          <Text variant="heading-sm" as="h3">
            Perilaku Kerja
          </Text>

          {/* TODO: Enable this button when the feature is ready */}
          <Button color="white" className="min-w-40 ml-auto" disabled={true}>
            Cek <span className="sr-only">Perilaku Kerja</span>
          </Button>
        </div>
      </div>
    </section>
  )
}
